var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtGeneratorCreditColored = function SvgIconArtGeneratorCreditColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__a)",
    d: "m9.698 3.922-.652 1.946a4.97 4.97 0 0 1-3.165 3.17l-1.967.654a.33.33 0 0 0 0 .63l1.967.653a4.95 4.95 0 0 1 3.14 3.146l.653 1.97a.331.331 0 0 0 .628 0l.678-1.945A4.97 4.97 0 0 1 14.12 11l1.966-.653a.33.33 0 0 0 0-.63l-1.942-.679a4.95 4.95 0 0 1-3.164-3.17l-.653-1.971a.332.332 0 0 0-.629.025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__b)",
    d: "m9.698 3.922-.652 1.946a4.97 4.97 0 0 1-3.165 3.17l-1.967.654a.33.33 0 0 0 0 .63l1.967.653a4.95 4.95 0 0 1 3.14 3.146l.653 1.97a.331.331 0 0 0 .628 0l.678-1.945A4.97 4.97 0 0 1 14.12 11l1.966-.653a.33.33 0 0 0 0-.63l-1.942-.679a4.95 4.95 0 0 1-3.164-3.17l-.653-1.971a.332.332 0 0 0-.629.025"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__c)",
    fillRule: "evenodd",
    d: "M9.977 3a1.015 1.015 0 0 1 1 .682l.653 1.973a4.28 4.28 0 0 0 2.728 2.733l.012.004 1.936.677a1.015 1.015 0 0 1-.007 1.928l-1.962.652a4.28 4.28 0 0 0-2.708 2.713l-.003.009-.677 1.941v.003a1.016 1.016 0 0 1-1.922-.003l-.002-.005-.653-1.971a4.28 4.28 0 0 0-2.707-2.711l-1.964-.653a1.014 1.014 0 0 1 0-1.93l1.964-.653h.002a4.28 4.28 0 0 0 2.73-2.735V5.65l.65-1.937a1.02 1.02 0 0 1 .93-.712m5.9 7.369-.008-.003z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__d)",
    fillRule: "evenodd",
    d: "M9.977 3a1.015 1.015 0 0 1 1 .682l.653 1.973a4.28 4.28 0 0 0 2.728 2.733l.012.004 1.936.677a1.015 1.015 0 0 1-.007 1.928l-1.962.652a4.28 4.28 0 0 0-2.708 2.713l-.003.009-.677 1.941v.003a1.016 1.016 0 0 1-1.922-.003l-.002-.005-.653-1.971a4.28 4.28 0 0 0-2.707-2.711l-1.964-.653a1.014 1.014 0 0 1 0-1.93l1.964-.653h.002a4.28 4.28 0 0 0 2.73-2.735V5.65l.65-1.937a1.02 1.02 0 0 1 .93-.712m5.9 7.369-.008-.003z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__e)",
    d: "m14.662 3.744-.164.486a1.24 1.24 0 0 1-.791.793l-.492.163a.08.08 0 0 0-.057.079.08.08 0 0 0 .057.079l.492.163a1.24 1.24 0 0 1 .785.786l.163.493a.08.08 0 0 0 .079.056.08.08 0 0 0 .078-.056l.17-.486a1.24 1.24 0 0 1 .785-.787l.491-.163a.083.083 0 0 0 0-.158l-.485-.17a1.24 1.24 0 0 1-.791-.792l-.163-.493a.083.083 0 0 0-.158.007"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__f)",
    d: "m14.662 3.744-.164.486a1.24 1.24 0 0 1-.791.793l-.492.163a.08.08 0 0 0-.057.079.08.08 0 0 0 .057.079l.492.163a1.24 1.24 0 0 1 .785.786l.163.493a.08.08 0 0 0 .079.056.08.08 0 0 0 .078-.056l.17-.486a1.24 1.24 0 0 1 .785-.787l.491-.163a.083.083 0 0 0 0-.158l-.485-.17a1.24 1.24 0 0 1-.791-.792l-.163-.493a.083.083 0 0 0-.158.007"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__g)",
    fillRule: "evenodd",
    d: "M14.717 3.158a.61.61 0 0 1 .601.414l.164.495a.71.71 0 0 0 .455.456l.01.003.482.168a.61.61 0 0 1-.006 1.156l-.49.163a.72.72 0 0 0-.452.453l-.002.007-.17.485a.609.609 0 0 1-1.152-.002l-.001-.004-.163-.493a.72.72 0 0 0-.452-.453l-.49-.163a.609.609 0 0 1 0-1.157l.492-.163a.72.72 0 0 0 .455-.457L14 4.063l.162-.482a.61.61 0 0 1 .556-.423m-.348 2.108a1.8 1.8 0 0 1 .37.373 1.8 1.8 0 0 1 .373-.372 1.8 1.8 0 0 1-.372-.372 1.8 1.8 0 0 1-.371.37",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_art_generator_credit_colored_svg__h)",
    fillRule: "evenodd",
    d: "M14.717 3.158a.61.61 0 0 1 .601.414l.164.495a.71.71 0 0 0 .455.456l.01.003.482.168a.61.61 0 0 1-.006 1.156l-.49.163a.72.72 0 0 0-.452.453l-.002.007-.17.485a.609.609 0 0 1-1.152-.002l-.001-.004-.163-.493a.72.72 0 0 0-.452-.453l-.49-.163a.609.609 0 0 1 0-1.157l.492-.163a.72.72 0 0 0 .455-.457L14 4.063l.162-.482a.61.61 0 0 1 .556-.423m-.348 2.108a1.8 1.8 0 0 1 .37.373 1.8 1.8 0 0 1 .373-.372 1.8 1.8 0 0 1-.372-.372 1.8 1.8 0 0 1-.371.37",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__a",
    x1: 4.737,
    x2: 15.264,
    y1: 4.737,
    y2: 15.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__b",
    x1: 10,
    x2: 10,
    y1: 1.579,
    y2: 18.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__c",
    x1: 4.737,
    x2: 15.264,
    y1: 4.737,
    y2: 15.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__d",
    x1: 10,
    x2: 10,
    y1: 1.579,
    y2: 18.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__e",
    x1: 4.737,
    x2: 15.264,
    y1: 4.737,
    y2: 15.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__f",
    x1: 10,
    x2: 10,
    y1: 1.579,
    y2: 18.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__g",
    x1: 4.737,
    x2: 15.264,
    y1: 4.737,
    y2: 15.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_art_generator_credit_colored_svg__h",
    x1: 10,
    x2: 10,
    y1: 1.579,
    y2: 18.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })))));
};
export default SvgIconArtGeneratorCreditColored;